var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b-button',{attrs:{"variant":"-primary","size":"-small btn--fixed"},on:{"click":_vm.handleOpenSlicer}},[_vm._v(_vm._s(_vm.$t('apps.editor.slice')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }